<template>
    <div id="childForward" class="page-content">
        <!-- 转寄 -->
        <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body>
            <div v-for="(item, index) in returnList" @click="dinji(index)" style="margin-bottom: 20px;">
                <div style="display: flex;height: 50px;line-height: 50px;">
                    <el-input v-model="item.ordernumber" clearable disabled style="width: 178px;margin-right: 10px;"
                        size="small" v-if="type == 1" />

                    <div style="line-height: 56px;padding-right: 5px;color: #F56C6C;" v-if="type == 2">
                        *
                    </div>
                    <el-select v-model="item.ordernumber" placeholder="请选择订单编号" v-if="type == 2" size="small"
                        style="margin-right: 10px;width: 150px;" @change="selectChange(index, item.ordernumber)">
                        <el-option v-for="item in options" :key="item.ordernumber" :label="item.ordernumber"
                            :value="item.ordernumber">
                        </el-option>
                    </el-select>

                    <div style="line-height: 56px;padding-right: 5px;color: #F56C6C;">
                        *
                    </div>
                    <el-input v-model="item.forwardNumber" clearable placeholder="转寄数量"
                        style="width: 120px;margin-right: 10px;" type="number" size="small" />
                    <i class="el-icon-remove" style="line-height: 50px;padding-left: 10px;color: red;cursor: pointer;"
                        v-if="returnList.length != 0 && type == '2'" @click="del(index)"></i>
                </div>
            </div>
            <el-button type="primary" icon="el-icon-plus" size="small" style="margin-left: 10px;margin-top: 10px;"
                @click="newAdd" v-if="type == 2">新增</el-button>
            <el-form ref="form" :model="form" :rules="rules" label-width="150px"
                style="height: 500px;overflow: auto;margin-top: 20px;">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="转寄收件人" prop="forwardRecipient">
                            <el-input v-model="form.forwardRecipient" clearable placeholder="转寄收件人"
                                style="width: 410px;" size="small" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="转寄收件人手机号" prop="forwardRecipientPhone">
                            <el-input v-model="form.forwardRecipientPhone" clearable placeholder="转寄收件人手机号"
                                style="width: 410px;" size="small" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="转寄收件人地址" prop="forwardAddress">
                            <el-input v-model="form.forwardAddress" clearable placeholder="转寄收件人地址"
                                style="width: 410px;" size="small" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="转寄运费支付日期" prop="forwardPaymentDate">
                            <el-date-picker v-model="form.forwardPaymentDate" value-format="yyyy-MM-dd" type="date"
                                placeholder="请选择" style="width: 410px;" size="small"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="转寄快递单号" prop="forwardTrackingNumber">
                            <el-input v-model="form.forwardTrackingNumber" clearable placeholder="转寄快递单号"
                                style="width: 410px;" size="small" />
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="转寄运费支付截图" prop="forwardPaymentScreenshot">
                            <el-upload class="upload-demo" action="/hcm/hcmWorkOrder/headImgUploadOrder"
                                :show-file-list="false" :before-upload="handleBeforeUpload"
                                :on-success="handleUploadSuccess" accept="image/png, image/jpg" :multiple="true"
                                :ref="elUpload">
                                <el-button size="small" type="primary">点击上传</el-button>
                            </el-upload>
                            <div v-for="(image, index) in forwardPaymentScreenshot" :key="index"
                                style="float: left;margin: 10px 10px 0px 0px;position: relative;">
                                <img :src="image" class="avatar" style="width: 100px; height: 100px;font-size: 20px;" />
                                <i class="el-icon-error"
                                    style="position: absolute;right: 10px;top: 10px;cursor: pointer;"
                                    @click="delIcon(index)"></i>
                            </div>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="转寄运费金额" prop="forwardPaymentPrice">
                            <el-input v-model="form.forwardPaymentPrice" clearable placeholder="转寄运费金额"
                                style="width: 410px;" size="small" type="number" />
                        </el-form-item>
                    </el-col>

                    <el-col :span="24" v-if="title == '转寄详情'">
                        <el-form-item label="创建时间">
                            {{ form.createtime | fullTime }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="title == '转寄详情'">
                        <el-form-item label="创建人">
                            {{ form.createuser }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="title == '转寄详情'">
                        <el-form-item label="更新时间" v-if="form.updatetime">
                            {{ form.updatetime | fullTime }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="title == '转寄详情'">
                        <el-form-item label="更新人" v-if="form.updateuser">
                            {{ form.updateuser }}
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel(2)">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "childForward",
    props: {
        type: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            elUpload: true,
            title: '',
            form: {},
            rules: {
                forwardRecipient: [
                    { required: true, message: '请填写转寄收件人', trigger: 'blur' },
                ],
                forwardRecipientPhone: [
                    { required: true, message: '转寄收件人手机号', trigger: 'blur' },
                ],
                forwardPaymentDate: [
                    { required: true, message: '请选择转寄运费支付日期', trigger: 'blur' },
                ],
                forwardAddress: [
                    { required: true, message: '请填写转寄收件人地址', trigger: 'blur' },
                ],
                forwardTrackingNumber: [
                    { required: true, message: '请填写转寄快递单号', trigger: 'blur' },
                ],
                forwardPaymentScreenshot: [
                    { required: true, message: '请选择转寄运费支付截图', trigger: 'blur' },
                ],
                forwardPaymentPrice: [
                    { required: true, message: '请填写转寄运费金额', trigger: 'blur' },
                ],
            },
            rules2: {},
            open: false,
            returnList: [],
            dynamicRules: this.rules,
            options: [],
            forwardPaymentScreenshot: [],
        };
    },
    created() {

    },
    methods: {
        newAdd() {
            this.returnList.push({
                ordernumber: '',
                forwardNumber: '',
                orderid: '',
                ordertaskid: '',
            })
        },
        delIcon(index) {
            this.forwardPaymentScreenshot.splice(index, 1)
        },
        del(index) {
            this.returnList.splice(index, 1);
        },
        selectChange(index, ordernumber) {
            const orderNumberCounts = {};
            let hasDuplicates = false;

            this.returnList.forEach(item => {
                if (orderNumberCounts[item.ordernumber]) {
                    orderNumberCounts[item.ordernumber]++;
                    if (orderNumberCounts[item.ordernumber] > 1) {
                        hasDuplicates = true;
                    }
                } else {
                    orderNumberCounts[item.ordernumber] = 1;
                }
            });

            if (hasDuplicates) {
                this.$message.error('该订单已存在转寄');
                this.returnList[index].ordernumber = null
                return
            } else {
                console.log('没有重复的订单号');
            }
            for (let a in this.options) {
                if (this.options[a].ordernumber == ordernumber) {
                    this.returnList[index].orderid = this.options[a].id;
                    this.returnList[index].ordertaskid = this.options[a].taskid;
                }
            }
        },
        updateChange(data) {
            this.form = {};
            this.title = data.title;
            console.log(data)
            if (data.form.forwardidlistList) {
                this.returnList = []
                this.returnList = data.form.forwardidlistList;
            }
            if (this.type == '2') {
                if (data.form) {
                    this.form = data.form.details;
                    this.form.forwardPaymentDate = this.$options.filters.fullTime(this.form.forwardPaymentDate);
                    this.forwardPaymentScreenshot = data.form.details.forwardPaymentScreenshot.split(',');
                }
                this.OrderChange();
            } else {
                this.open = true;
            }
        },
        // 获取订单编号
        OrderChange() {
            let params = {}
            fetch({
                url: "hcm/hcmOrdergoods/getListOrderPaynumsurplus",
                method: "get",
                noFormat: true,
                params: params,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.options = [];
                    if (result.data.length > 0) {
                        for (let a in result.data) {
                            if (result.data[a].buytype !== 'R买') {
                                this.options.push(result.data[a])
                            }
                        }
                    }
                    if (this.form && this.form.ordernumber) {

                    } else {
                        this.returnList.push({
                            forwardNumber: '',
                            ordernumber: '',
                            orderid: '',
                            ordertaskid: '',
                        });
                    }
                    this.open = true;
                }
            })
        },
        // 图片上传前判断
        handleBeforeUpload(file) {
            const isLt20M = file.size / 1024 / 1024 < 20;
            if (!isLt20M) {
                this.$message.error('上传文件大小不能超过 20MB!');
            }
            return isLt20M;
        },
        handleUploadSuccess(res) {
            this.forwardPaymentScreenshot.push(res.data.data);
            this.elUpload = false;
        },
        dinji(index) {
            console.log(index)
            this.dianjiIndex = index;
        },
        // 提交
        submitForm() {
            let ordernumber = []
            let data = []
            for (var i in this.returnList) {
                const item = this.returnList[i];
                if (item.ordernumber === '' || !item.ordernumber) {
                    this.$message({
                        message: '请选择订单编号',
                        type: 'warning'
                    });
                    return
                }
                if (item.forwardNumber === '') {
                    this.$message({
                        message: '请填写转寄数量',
                        type: 'warning'
                    });
                    return
                }
                ordernumber.push(item.ordernumber)
            }
            this.form.orderforwardsubList = this.returnList
            this.form.ordernumber = ordernumber.join(',')
            this.form.forwardPaymentScreenshot = this.forwardPaymentScreenshot.join(',')
            fetch({
                url: "hcm/hcmOrderForward/savaOrderForward",
                method: "post",
                data: JSON.stringify(this.form),
                headers: {
                    'Content-Type': 'application/json',
                },
                noFormat: false,
                responseType: "json"
            }).then((res) => {
                if (res.status === '10000') {
                    this.$message({
                        message: '操作成功！',
                        type: 'success'
                    })
                    this.open = false;
                } else {
                    this.$message.error(res.message);
                }
                this.$emit('call-parent-method');
            }).catch(err => {
                this.$message.error('服务器出错');
            });
        },
        // 取消
        cancel() {
            this.open = false;
        },
    }
};
</script>
<style scoped>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    height: 50px;
    width: 50px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

#childForward {
    .el-table th {
        background-color: #f3f7ff !important;
    }

    .el-table__empty-text {
        padding-top: 100px;
        background: url("../../../assets/img/other/nodata.svg") no-repeat;
        background-position: center 66px;
    }

    .el-dialog__header {
        padding: 20px 20px 10px;
        border-bottom: 1px solid #d9d9d9;
    }

    .el-table thead {
        color: #333333;
        font-weight: 500;
    }

    .el-button+.el-button {
        margin-left: 0px;
    }

    .bottom_page .el-pagination {
        text-align: right;
        margin-top: 0px;
        padding-bottom: 0px;
    }
}
</style>